import React from "react";

export default function NinjaTraderWebTerminal() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-slate-300">
      <p className="text-sm">⚙️ NinjaTrader web embedding is not officially supported.</p>
      <a
        href="https://ninjatrader.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-400 underline mt-2"
      >
        Open NinjaTrader Website
      </a>
    </div>
  );
}
